define('responsive-gameday/views/render/TeamMatchupSummaryViewRender',['require','exports','module','./ViewRender','gameday-index-url-hasher/UrlHasher','gameday-index-enums/enums/baseball/GameStates','Wax/get!view-templates/teamMatchup/summary','Wax/get!view-templates/linescore/embeddedLinescore','Wax/get!view-templates/linescore/bases','Wax/get!view-templates/matchup/matchup','Wax/get!view-templates/matchup/batter','Wax/get!view-templates/matchup/pitcher'],function(require,exports,module){
    var ViewRender  = require('./ViewRender'),
        UrlHasher   = require( "gameday-index-url-hasher/UrlHasher" ),
        GameStates = require("gameday-index-enums/enums/baseball/GameStates"),
        Superclass;

    function TeamMatchupViewRender(){
        Superclass.constructor.call(this,
            require('Wax/get!view-templates/teamMatchup/summary'),{
                embeddedLinescoreView   : require( 'Wax/get!view-templates/linescore/embeddedLinescore' ),
                basesView               : require( "Wax/get!view-templates/linescore/bases" ),
                matchupView             : require( "Wax/get!view-templates/matchup/matchup" ),
                matchupBatterView       : require( "Wax/get!view-templates/matchup/batter" ),
                matchupPitcherView      : require( "Wax/get!view-templates/matchup/pitcher" )
            }
        );
    }
    ViewRender.spawn(TeamMatchupViewRender).define({
        viewContext : function(context){
            var viewContext = Superclass.viewContext.call(this,context),
                renderModeText = (UrlHasher.getCachedParams().game_state).toLowerCase(),
                renderMode = {};

            renderMode[renderModeText]=true;
            renderMode.className = (UrlHasher.getCachedParams().game_state).toLowerCase();

            viewContext.viewState.renderMode=renderMode;
            return viewContext;
        }

    });

    Superclass=TeamMatchupViewRender.superclass;

    return TeamMatchupViewRender;
});
